/* eslint-disable no-unused-expressions */
import { FileUpload } from "./file.upload";
import { getFileExtension, generateShortId } from "./picker.utils";
import { FileValidation } from "./picker.validations";
import { UploadService } from "./upload.service";
import { defaultConfig } from "./picker.constants";

export class UploadWrapper {
  constructor(baseURL, prefix, config = defaultConfig) {
    this.prefix = prefix;
    this.config = config;
    this.baseURL = baseURL;
    this.config.minSize = config.minSize || 2;
    this.statusCallback = "";
  }

  setProgressStatus(data) {
    if (data.status === "error") {
      this.statusCallback(data, null);
    } else {
      this.statusCallback(null, data);
    }
  }

  upload(file, isPublic = false, callback = () => {}) {
    file.fileExtension = getFileExtension(file.name);
    this.config.isProfile = isPublic;
    file.mimeType = file.type;
    this.statusCallback = callback;
    file.setStatus = this.setProgressStatus.bind(this);
    file.id = generateShortId("Attach");
    this.config.validSelectedFile = [file.id];

    let noError = this.validate(file);
    if (noError === true) {
      let uploadFile = new FileUpload(file, this.prefix, this.config);
      uploadFile.upload(this.baseURL, callback);
    } else {
      callback(noError, null);
    }
  }

  validate(file) {
    let validation = new FileValidation(this.config, file);
    return validation.validate();
  }

  uploadFromUrl(
    {
      url,
      name = "",
      flowType = "",
      flowId = "",
      instanceId = "",
      fieldId = "",
      isPublic = false,
      toast = true,
      shouldIncludeAttachmentId = true
    },
    callback = () => {}
  ) {
    let attachmentId = "";

    if (shouldIncludeAttachmentId) {
      attachmentId = generateShortId("Attach");
    }

    let prefix = [flowType, flowId, instanceId, fieldId, attachmentId, name]
      .filter(Boolean)
      .join("/");

    let data = {
      Name: name,
      Prefix: `${prefix}/`,
      URL: url,
      IsPublic: isPublic,
      Size: this.config.imageProps.sizes,
      GenerateThumbnail: true
    };
    let [uploadPromise, cancelPromise] = UploadService.uploadImageUrl(
      data,
      toast
    );
    this.cancelRequest = cancelPromise;
    uploadPromise()
      .then((res) => callback(null, res))
      .catch((err) => callback(err, null));
  }
}
